"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagingMode = void 0;
var PagingMode;
(function (PagingMode) {
    PagingMode["Offset"] = "OFFSET";
    PagingMode["Cursor"] = "CURSOR";
})(PagingMode = exports.PagingMode || (exports.PagingMode = {}));
//# sourceMappingURL=pagingMode.js.map